module.exports = __webpack_public_path__ + "UtilizationStudentReport-674d726e88abf5efa7173eb648aa373f.png";